<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">人员：</span>
        </div>
        <el-input v-model="formData.personName" disabled size="small" style="width: 280px" />
      </div>
<!--      <div class="form-line">
        <div class="textBox">
&lt;!&ndash;          <b class="red">*</b>&ndash;&gt;
          <span class="line-text">房间号：</span>
        </div>
        <el-input v-model="formData.roomNumber" disabled size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
&lt;!&ndash;          <b class="red">*</b>&ndash;&gt;
          <span class="line-text">床位号：</span>
        </div>
        <el-input v-model="formData.bedsNumber" disabled size="small" style="width: 280px" />
      </div>-->
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">承租主体：</span>
        </div>
        <el-select v-model="formData.leaseCode" filterable remote reserve-keyword placeholder="请输入关键词" size="mini" style="width: 280px" :remote-method="getLeaseList" @change="changeLeaseCode">
          <el-option v-for="item in leaseList" :key="item.code" :label="item._label" :value="item.code"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">房间号：</span>
        </div>
        <el-select v-model="leaseRoomCode" placeholder="请选择" size="mini" style="width: 280px" @change="changeRoomCode">
          <el-option v-for="item in leaseRoomList" :key="item.code" :label="item._label" :value="item.code"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">初始化电量：</span>
        </div>
        <el-input v-model="formData.initElectricity" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">初始化水量：</span>
        </div>
        <el-input v-model="formData.initWaterity" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">附件：</span>
        </div>
        <input id="upload" name="file" accept="image/*" type="file"
               @change="upData" style="display: none;" />
        <a @click="upImg" class="photoBox" style="position:relative">
          <p class="add" v-if="!formData.attachments">✚</p>
          <img :src="formData.attachments" id="peopleImg" class="img" v-if="formData.attachments" />
        </a>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {errorHandler} from '../../../utils/errorHandler'
import {api} from '../../api/Person'
import {nError, nSuccess} from '../../../utils/notice'
import {pattern} from '../../../utils/regular'
import {bus} from '../../../utils/bus'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'person-check-in',
  data () {
    return {
      yqCode: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '人员入住'
      }],
      mainTitle: '人员入住',
      subheading: '',
      leaseList: [],
      leaseRoomList: [],
      leaseRoomCode: '',
      formData: {
        id: '',
        code: "",//编号
        leaseCode: "",//租赁编号
        personCode: "",//人员编号
        personName: "",//人员姓名
        roomCode: "",//房间编号
        roomNumber: "",//房间号
        bedsCode: "",//床位编号
        bedsNumber: "",//床位号
        initElectricity: '',//初始化电量
        initWaterity: '',//初始化水量
        initSteamity: '',//初始化蒸汽量
        initGasity: '',//初始化燃气量
        attachments: "",//附件地址
      },
      // dataValue: [],
      currentCode: ''
    }
  },
  created () {
    this.yqCode = bus.global.yqCode;
    let data = this.$route.params.data;
    this.formData.code = data.code === '--' ? '' : data.code;
    this.formData.leaseCode = data.leaseCode === '--' ? '' : data.leaseCode;
    this.formData.personCode = data.code === '--' ? '' : data.code;
    this.formData.personName = data.name === '--' ? '' : data.name;
    this.formData.roomCode = data.roomCode === '--' ? '' : data.roomCode;
    this.formData.roomNumber = data.roomNumber === '--' ? '' : data.roomNumber;
    this.formData.bedsCode = data.bedsCode === '--' ? '' : data.bedsCode;
    this.formData.bedsNumber = data.bedsNumber === '--' ? '' : data.bedsNumber;
    this.getLeaseList('')

  },
  mounted() {
    console.log(this.$route.params.data, 'num')
  },
  methods: {
    toPersonManagement () {
      this.$router.push({
        name: 'person-management'
      })
    },

    getPersonByCode () {
      // this.$axios.get(`${api.getPersonByCode}/${this.currentCode}`, {})
      //   .then(res => {
      //     if (res.data.retCode === 1) {
      //       let data = res.data.data
      //       this.formData = data
      //     }
      //   })
      //   .catch(errorHandler('查询人员入住信息失败'))
    },
    upData() {
      const that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("upload").files[0];
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function(oFRevent) {
        const src = oFRevent.target.result;
        $("#peopleImg").attr("src", src);
        that.formData.attachments = src;
        that.uploadPictures();
      };
    },
    upImg() {
      $("#upload")
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on("change", function() {
          const objUrl = getObjectURL(this.files[0]); // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            $("#peopleImg").attr("src", objUrl); // 将图片路径存入src中，显示出图片
            window.sessionStorage.setItem("img", objUrl);
          }
        });
    },

    // 上传base64获取图片地址
    uploadPictures () {
      this.$axios.post(api.commonUploadImg, {
        picData: this.formData.attachments
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData.attachments = res.data.data;
          } else {
            // 提示信息，需引入Message
            nError('图片上传失败')
          }
        })
        .catch(errorHandler('图片上传失败'))
    },
    // 获取承租主体列表
    getLeaseList (searchKey) {
      this.$axios.post(api.getLeaseList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let data = res.data.data
          data.map(v => {
            if (v.enterpriseName) {
              v._label = `${v.enterpriseName}/${v.personName}/${v.phone}`
            } else {
              v._label = `${v.personName}/${v.phone}`
            }
          })
          this.leaseList = data

          this.leaseList.map(v => {
            if (v.code === this.formData.leaseCode) {
              let leaseRoomBindList = v.leaseRoomBindList || []
              leaseRoomBindList.map(roomInfo => {
                if (roomInfo.bedsNumber) {
                  roomInfo._label = `${roomInfo.buildingName}/${roomInfo.floorName}/${roomInfo.roomNumber}/${roomInfo.bedsNumber}`
                } else {
                  roomInfo._label = `${roomInfo.buildingName}/${roomInfo.floorName}/${roomInfo.roomNumber}`
                }
                if (this.formData.bedsCode) {
                  if (this.formData.bedsCode === roomInfo.bedsCode && this.formData.roomCode === roomInfo.roomCode ) {
                    this.leaseRoomCode = roomInfo.code
                  }
                } else {
                  if (this.formData.roomCode === roomInfo.roomCode ) {
                    this.leaseRoomCode = roomInfo.code
                  }
                }
              })
              this.leaseRoomList = leaseRoomBindList
            }
          })
        })
        .catch(errorHandler('添加失败'))
    },

    // 承租主体变更
    changeLeaseCode (value) {
      console.log(value)
      this.leaseRoomCode = ''
      this.formData.roomCode = ''
      this.formData.roomNumber = ''
      this.formData.bedsCode = ''
      this.formData.bedsNumber = ''
      this.leaseList.map(v => {
        if (v.code === value) {
          let leaseRoomBindList = v.leaseRoomBindList || []
          leaseRoomBindList.map(roomInfo => {
            if (roomInfo.bedsNumber) {
              roomInfo._label = `${roomInfo.buildingName}/${roomInfo.floorName}/${roomInfo.roomNumber}/${roomInfo.bedsNumber}`
            } else {
              roomInfo._label = `${roomInfo.buildingName}/${roomInfo.floorName}/${roomInfo.roomNumber}`
            }
          })
          this.leaseRoomList = leaseRoomBindList
        }
      })
    },
    // 选择房间号
    changeRoomCode (value) {
      this.leaseRoomList.map(roomInfo => {
        if (roomInfo.code === value) {
          this.formData.roomCode = roomInfo.roomCode
          this.formData.roomNumber = roomInfo.roomNumber
          this.formData.bedsCode = roomInfo.bedsCode
          this.formData.bedsNumber = roomInfo.bedsNumber
        }
      })
    },

    confirm () {
      if (!this.formData.leaseCode) {
        nError('请选择承租主体')
        return false
      }else if (!this.formData.roomCode) {
        nError('请选择房间')
        return false
      }
      else if (!this.formData.initElectricity) {
        nError('请输入初始化电量')
        return false
      } else if (!this.formData.initWaterity) {
        nError('请输入初始化水量')
        return false
      }
      console.log(this.formData)
      this.$axios.post(api.checkIn, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('入住成功')
            this.toPersonManagement()
          }
        })
        .catch(errorHandler('入住失败'))
    },
    cancel () {
      this.toPersonManagement()
    }
  },
  watch: {
    // dataValue (v) {
    //   this.formData.cardStartTime = v[0]
    //   this.formData.cardEndTime = v[1]
    // }
  }
}
function getObjectURL (file) {
  let url = null
  if (window.createObjectURL !== undefined) { // basic
    url = window.createObjectURL(file)
  } else if (window.URL !== undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file)
  } else if (window.webkitURL !== undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file)
  }
  return url
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
  position: relative;
}
/*form .photoBox {*/
/*  width: 120px;*/
/*  height: 160px;*/
/*  border: 1px dashed #dcdfe6;*/
/*  border-radius: 5px;*/
/*  position: absolute;*/
/*  left: 450px;*/
/*  top: 0;*/
/*}*/
.personExample {
  position: absolute;
  bottom: -30px;
  text-align: center;
  left: 0;
  right: 0;
  margin: 0 auto;
  color: #00a0e6;
  cursor: pointer;
}
/*.photoBox img {*/
/*  width: 100%;*/
/*  height: 100%;*/
/*}*/
/*.photoBox p {*/
/*  color: #999999;*/
/*  font-size: 12px;*/
/*  text-align: center;*/
/*}*/
.red {
  color: #FF0000;
}
.form-line {
  margin: 0 0 15px 0;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.photoBox {
  width: 160px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 5px;
}
.add {
  font-size: 36px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img {
  width: 160px;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/PersonManagement/personCheckIn.vue